const ONBOARDING_FLOW_TYPES = Object.freeze({
  landing: 'landing',
  auth: 'auth',
  paywall: 'paywall',
});

export default ONBOARDING_FLOW_TYPES;
